import script from "./ContributorLeaderboardTop.vue?vue&type=script&setup=true&lang=js"
export * from "./ContributorLeaderboardTop.vue?vue&type=script&setup=true&lang=js"

import "./ContributorLeaderboardTop.vue?vue&type=style&index=0&id=3fa6efac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fa6efac"]])

export default __exports__